import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryFeature() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            六大热门分类，快速找到你喜欢的韩漫类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name}漫画 - 韩漫免费漫画在线观看下拉式`}
                title={`${cat.name}漫画 - 好看韩漫漫画免费漫画`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <h3 className="font-heading text-2xl md:text-3xl text-white mb-2 drop-shadow-lg">
                  {cat.name}
                </h3>
                <p className="text-sm text-white/80 drop-shadow-md">{cat.description}</p>
                <span className="mt-3 px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs text-white whitespace-nowrap">
                  {cat.count} 部作品
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}